<template>
  <form class="needs-validation" @submit.prevent="payment" novalidate>
    <section class="bg-white rounded mb-2 p-3 p-sm-4">
      <div class="row">
        <div class="col-12 mb-3">
          <h1 class="h2">Your Cart</h1>
          <div role="alert" class="alert alert-warning" v-if="errors">{{errors}}</div>
        </div>

        <div class="col-12" v-if="memberUpdate">
          <table class="table table-striped table-bordered border-0" v-if="!$store.state.showExpand && memberUpdate.length > 0">
            <thead>
              <tr>
                <th class="position-relative">First name</th>
                <th class="position-relative">Last Name</th>
                <th class="position-relative">Type</th>
                <th class="position-relative column-lg-small" align="center">Price</th>
                <th class="position-relative column-lg-small"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(member, index) in memberUpdate" :key="index">
                <td>{{member.first_name}}</td>
                <td>{{member.last_name}}</td>
                <td>{{member.type}}</td>
                <td align="right">${{cartList[index].price}}</td>
                <td>
                  <button :class="['btn btn-block', processing[index] ? 'btn-primary-dark' : 'btn-primary']" @click="remove(index)">
                    {{ !processing[index] ? 'Remove' : '' }}
                    <div v-if="processing[index]" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>
                  </button>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr v-if="cartList.length > memberUpdate.length && cartIndex > (memberUpdate.length - 1)" v-for="(cartItem, cartIndex) in cartList" :key="cartIndex">
                <td colspan="3"><strong class="label">{{$store.state.discounts.filter((discount) => discount.id === cartItem.id)[0].name}}</strong></td>
                <td><strong>{{cartItem.price && typeof cartItem.price !== "string" ? cartItem.price.toFixed(2) : cartItem.price}}</strong></td>
                <td></td>
              </tr>
              <tr>
                <td align="right" colspan="4" class="border-0">
                  <strong>Your total: ${{total.toFixed(2)}}</strong>
                </td>
                <td class="border-0"></td>
              </tr>
              <tr>
                <td align="right" colspan="5" class="border-0">

                </td>
                <td class="border-0"></td>
              </tr>
            </tfoot>
          </table>

          <table class="table table-striped table-bordered border-0" v-else-if="memberUpdate.length > 0">
            <tbody>
              <tr v-for="(member, index) in memberUpdate" :key="index">
                <td>
                  <div class="d-sm-flex justify-content-between align-items-center">
                    <div class="mb-2 mb-sm-0">
                      {{member.first_name}} {{member.last_name}}<br><br>
                      <strong class="label">Type: </strong> {{member.type}}<br>
                      <strong class="label">Price: </strong> {{cartList[index].price}}<br>
                    </div>
                    <div class="flex-shrink-1">
                      <button class="btn btn-block btn-primary" @click="remove(index)">Remove</button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr v-if="cartList.length > memberUpdate.length && cartIndex > (memberUpdate.length - 1)" v-for="(cartItem, cartIndex) in cartList" :key="cartIndex">
                <td colspan="3">
                  <div class="d-sm-flex justify-content-between align-items-center">
                    <strong class="label">{{$store.state.discounts.filter((discount) => discount.id === cartItem.id)[0].name}}</strong>
                    <div class="flex-shrink-1">
                      <strong>{{cartItem.price && typeof cartItem.price !== "string" ? cartItem.price.toFixed(2) : cartItem.price}}</strong>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td align="center" class="border-0">
                  <strong>Your total: ${{total.toFixed(2)}}</strong>
                </td>
              </tr>
            </tfoot>
          </table>

          <div class="form-group form-check px-0 mb-sm-4">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="rules" required v-model="rules">
              <label class="custom-control-label" for="rules">
                By checking this box, I agree to adhere to the General Information Competition Rules and Guidelines, the ACA Constitution and Disciplinary Bylaw.
              </label>
            </div>
          </div>

          <div class="form-group form-check px-0 mb-sm-4">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="terms" required v-model="terms">
              <label class="custom-control-label" for="terms">
                In consideration for me, and/or minors in my care, being allowed to participate in all events run by the Australian Campdraft Association Inc. (ACA), I hereby agree that I have permission to accept the membership waiver, on behalf of all persons for whom this membership is for, a full copy of which is available on the ACA website and the membership tax invoice.
              </label>
              <div class="invalid-tooltip">Please agree to the membership waiver.</div>
            </div>
          </div>
        </div>

        <div class="col-12" v-else>
          <div role="alert" class="alert alert-info">Your cart is empty</div>
        </div>

        <div class="col-12 d-flex flex-wrap justify-content-end">
          <router-link v-if="backTo === 'members'" tag="button" class="btn btn-block-mob btn-outline-primary order-1 order-lg-0" :to="{ name: 'Add Members' }">Back to Add Members</router-link>
          <router-link v-else-if="userRole === 'Member' || userRole === 'Secretary'" tag="button" class="btn btn-block-mob btn-outline-primary order-1 order-lg-0" :to="{ name: 'My Profile', params: { renewing: true, tabSelect: 'membership', preselectedYear: preselectedYear } }">Back to Membership</router-link>
          <router-link v-else tag="button" class="btn btn-block-mob btn-outline-primary order-1 order-lg-0" :to="{ name: 'Member Profile', params: { renewing: true, tab: 'membership', preselectedYear: preselectedYear } }">Back to Membership</router-link>
          <button v-if="cartList ? cartList.length > 0 : false" :class="['btn btn-block-mob btn-primary mb-2 mb-lg-0 ml-lg-2', { 'disabled': (!terms || !rules) }]" @click="handleSubmit">Proceed to Payment</button>
        </div>
      </div>
    </section>
  </form>
</template>

<script>
import axios from 'axios'
import HANDLESUBMIT from '@/mixins/formValidation.js'

export default {
  name: 'Cart',
  props: {
    cartMembers: {
      type: Object,
      default: {
        items: [],
        users: [],
        total: 0
      }
    },
    backTo: {
      type: String,
      default: 'members'
    },
    preselectedYear: String
  },
  mixins: [HANDLESUBMIT],
  data() {
    return {
      errors: '',
      total: this.cartMembers.total,
      memberUpdate: this.cartMembers.users,
      cartList: this.cartMembers.items,
      // eslint-disable-next-line
      processing: this.cartMembers.items ? [...this.cartMembers.items.map(item => false)] : [],
      terms: false,
      rules: false,
      userRole: localStorage.role
    }
  },
  methods: {
    remove(index) {
      let data = [...this.cartList]
      if (data.length > 1) {
        data.splice(index, 1)
        // eslint-disable-next-line
        // console.log(data)
        data = data.filter(item => !item.hasOwnProperty('products'))
        data = data.map(item => item.id)
        // eslint-disable-next-line
        // console.log(data)
        this.processing.splice(index, 1, true)
        const parentId = this.memberUpdate.filter(row => row.parent_id).length > 0 ? this.memberUpdate.filter(row => row.parent_id)[0].parent_id : this.memberUpdate[0].id
        axios.post(`${this.$api}/total-cart`, { data, user_id: parentId }).then((response) => {
          // eslint-disable-next-line
          // console.log(response.data)
          this.processing.splice(index, 1, false)
          if (response.data.status === 'success') {
            const cart = response.data
            cart.payer_user_id = this.cartMembers.payer_user_id
            cart.payer_email = this.cartMembers.payer_email
            this.memberUpdate.splice(index, 1)
            cart.users = [...this.memberUpdate]
            this.$store.commit('updateCartMembers', cart)
            this.$emit('cartChanged')
          }
        }).catch((error) => {
          this.processing.splice(index, 1, false)
          // eslint-disable-next-line
          console.log(error)
        })
      } else {
        this.$store.commit('updateCartMembers', { items: [], total: 0, users: [] })
        this.$emit('cartChanged')
      }
    },
    payment() {
      setTimeout(() => {
        if (this.formComplete) {
          this.$router.push({ name: 'My Membership Payment' })
        }
      }, 10)
    }
  },
  watch: {
    cartMembers: {
      deep: true,
      handler() {
        this.total = this.cartMembers.total
        this.memberUpdate = this.cartMembers.users
        this.cartList = this.cartMembers.items
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/MyMembership/Cart/Cart.vue